<template>
    <div class="question-block p-4 mb-2">
        <div class="question pl-4 pr-5" @click="toggleAnswer">
            <span> {{ questionNumberFormat }}. </span>
            <slot name="question" :answerShowing="answerShowing">Question</slot>
            <i class="material-icons text-right" :class="{ 'text-primary': answerShowing }" aria-hidden="true">
                {{ answerShowing ? "remove_circle_outline" : "add_circle_outline" }}
            </i>
        </div>
        <b-collapse v-model="answerShowing" class="answer ml-4">
            <div class="mt-4">
                <slot name="answer">Answer</slot>
            </div>
        </b-collapse>
        <hr class="solid margin-top-20" />
    </div>
</template>

<script>
export default {
    name: "Faq",
    props: {
        questionNumber: {
            type: Number,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            answerShowing: false,
        };
    },
    computed: {
        questionNumberFormat() {
            if (this.questionNumber <= 9) {
                return "0" + this.questionNumber;
            }
            return this.questionNumber;
        },
    },
    methods: {
        toggleAnswer() {
            this.answerShowing = !this.answerShowing;
        },
    },
};
</script>

<style lang="scss" scoped>
.question-block {
    font-size: px2rem(16);
    position: relative;
    max-width: 700px;
    margin: 0 auto;
    .question {
        letter-spacing: px2rem(1.8);
        line-height: px2rem(19);
        text-transform: uppercase;
        cursor: pointer;
        /* prevent text from wrapping under the bullet */
        text-indent: px2rem(-33.6);

        .material-icons {
            font-weight: normal;
            font-size: px2rem(20);
            position: absolute;
            top: 20px;
            left: 95%;
        }
    }
    .answer {
        opacity: 0.8;
        letter-spacing: 0;
        line-height: px2rem(25);
    }
    .margin-top-20 {
        margin-top: px2rem(30);
    }
}
</style>
